var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import ClientService from '../../api/ClientService';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            name: '',
            sort: ''
        };
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        if (this.group) {
            this.formData.name = this.group.group_name;
            this.formData.sort = this.group.sort;
        }
    };
    Dialog.prototype.inputChange = function () {
        if (this.formData.name.length > 20) {
            this.formData.name = this.formData.name.slice(0, 20);
        }
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.submitData = function () {
        var _this = this;
        if (!this.formData.name) {
            this.$message.error("请输入分组名称");
            return;
        }
        ;
        this.service.addGroup({
            group_name: this.formData.name,
            sort: this.formData.sort,
            id: this.group ? this.group.group_id : undefined
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success(_this.group ? '修改成功！' : '添加成功！');
                _this.close();
                _this.$emit(_this.group ? 'editGroup:ok' : 'addGroup:ok');
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
